module.exports = __webpack_public_path__ + "static/media/Combo Familiar_Web2025.5e775bfa.png";